export const cFormValidationMessages = {
    required: 'Validation-messages.required-field',
    passwordsDoNotMatch: 'Validation-messages.passwords-do-not-match',
};
